exports = module.exports = require("../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Yi13PqU0cbhAejjFTv9Ml{table-layout:fixed;overflow-wrap:break-word}", ""]);

// exports
exports.locals = {
	"fixedTable": "Yi13PqU0cbhAejjFTv9Ml"
};